import { createStore, stateSetterHandler } from '@muvi/react-common';
import { isDevtoolsEnabled } from '@/logic/state/store-devtools';

export type RouteHandlerState = {
  routeHandler: RouteHandlerOptions;
};

export interface RouteHandlerOptions {
  removeOnRouteChangeStartListener?: () => void;
  removeOnRouteChangeCompleteListener?: () => void;
  removeOnBeforeUnloadListener?: () => void;
}

const initState: RouteHandlerState = {
  routeHandler: {},
};

export const useRouteHandler = createStore({
  name: 'route-handler',
  devtools: isDevtoolsEnabled,
  persist: false,
})(initState as RouteHandlerState, set => {
  const handler = stateSetterHandler(set);
  return {
    setRouteHandler: handler('routeHandler'),
  };
});
